/**
 * Fase dell'interfaccia e-commerce (numerazione della sez. 17 del progetto, 00 contraddizione 2.7).
 * Fase 1: Panoramica, Negozi, pagina del negozio (Riepilogo, Cronologia, Avanzate), collegamento guidato
 * fino all'attesa di conferma, Sincronizzazioni. Le voci e le schede delle fasi successive restano
 * nascoste o mostrano uno stato vuoto chiaro. Si alza di uno a ogni rilascio di fase.
 * Fase 2: schede Catalogo, Giacenze, Clienti, Ordini e Funzioni del negozio, Prodotti nei negozi,
 * Conflitti, anteprima dell'effetto. Niente si vede senza un negozio (motore acceso), quindi alzarla non
 * cambia niente per le org esistenti.
 */
export const COMMERCE_UI_PHASE = 2;
